import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { DriverDisbursementDetailModule } from '@fleet/driver-shared';
import { ResponsiveElementModule } from '@fleet/layout';
import { TitleCaseAndCleanPipeModule } from '@fleet/pipes';
import { StatusChipModule } from '@fleet/ui';
import { DisbursementSearchResultsComponent } from './disbursement-search-results.component';
import { InternationalizationDatePipeModule } from '@fleet/internationalization';
import { provideTranslocoScope, TranslocoDirective } from '@jsverse/transloco';

const lazyTranslationloader = ['en_au', 'es', 'en_us'].reduce(
  (acc: { [key: string]: () => Promise<any> }, lang) => {
    acc[lang] = () => import(`./i18n/${lang}.json`);
    return acc;
  },
  {}
);
@NgModule({
  declarations: [DisbursementSearchResultsComponent],
  imports: [
    CommonModule,
    ResponsiveElementModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    TitleCaseAndCleanPipeModule,
    TranslocoDirective,
    DriverDisbursementDetailModule,
    StatusChipModule,
    InternationalizationDatePipeModule,
  ],
  exports: [DisbursementSearchResultsComponent],
  providers: [
    provideTranslocoScope({
      scope: 'disbursementSearchResults',
      loader: lazyTranslationloader,
    }),
  ],
})
export class DisbursementSearchResultsModule {}
